import { Pipe, PipeTransform, NgModule } from '@angular/core';

// <mat-option *ngFor='let friendTypes of setData.friendTypes | objtoarray' [value]='friendTypes.k'>{{ friendTypes.v }}</mat-option>
// Object {START: '출발', LINE: '줄수', ODDEVEN: '홀짝'}
@Pipe({name: 'objtoarray'})
export class ObjToArrayPipe implements PipeTransform  {
    transform(obj: any): any {

        if (typeof obj === 'undefined' || obj === null) {
            return null;
        }

        let myobj: any;
        const arr = Object.keys(obj).map((key) => {
            if (typeof obj[key] === 'object') {
                myobj = {k: null, v: {}};
                myobj.k = key;
                myobj.v = obj[key];
            } else {
                myobj = {k: key, v: obj[key]};
            }
            return myobj;
        });
        return arr;
    }
}

@NgModule({
    declarations: [ ObjToArrayPipe ],
    exports: [ ObjToArrayPipe ],
})
export class ObjToArrayPipeModule { }
